<template>
  <!--<el-menu-item v-if="item.show!==false" :index="item.id" @click.native="goPage(item.id)">-->
  <!--<i v-if="item.icon" :class="item.icon"></i>-->
  <!--<span slot="title">{{item.name}}</span>-->
  <!--</el-menu-item>-->
  <el-menu-item v-if="item.showMenu!==false" :index="item.code" @click.native="goPage(item.id)">
    <!-- <i v-if="item.icon" :class="item.icon"></i> -->
    <svg class="myIconStyle" aria-hidden="true">
      <use :xlink:href="'#' + item.icon"></use>
    </svg>
    <span slot="title">{{item.name}}</span>
  </el-menu-item>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'menuItem',
    props: {
      item: {
        Object,
        default: {
          id: '',
          name: '',
          icon: '',
        },
      },
    },
    data() {
      return {
        queryParams: {
          ids: [
            {value: 'cd36f491-1fc6-11e9-ac9c-00163e0c1923'},
          ],
        },
      };
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
      }),
    },
    methods: {
      ...mapActions({
        setResourceData: 'user/setResourceData',
      }),
      goPage(id) {
        this.getUserByFunctionResource(id);
        this.$router.push(this.item.path);
      },
      async getUserByFunctionResource(functionId) {
        this.queryParams.functionId = functionId;
        const res = await this.$services.postStorage({
          type: 'USERMANGEMENT',
          url: 'getUserByFunctionResource',
          cache: true,
          params: {
            ids: JSON.stringify([{value: this.userInfor.roleId}]),
          },
        });
        if (res.bean[0]) {
          this.setResourceData(res.bean[0].code);
        }
      },
    },
  };
</script>

<style>
  .myIconStyle {
    width: 20px;
    height: 20px;
    fill: currentColor;
    overflow: hidden;
    color: #909399;
    margin-right: 5px;
  }
</style>
